import { Action } from 'typescript-fsa';
import { getUserGroupAdminApi2 } from '../../../components/System/systemConfig';
import { fetchWrapperFunc } from '../../../utils';
import { ugtsSetEntities, UGTS_LOAD, UgtsSubscription, ugtsLoad, UGTS_SUBSCRIBE, UGTS_UNSUBSCRIBE } from './actions';
import { all, put, takeLatest } from 'redux-saga/effects';

function* ugtsLoadGenerator(action: Action<string>) {
    const ugId = action.payload;
    const api = getUserGroupAdminApi2();

    yield* fetchWrapperFunc(() => api.getUserGroupTournamentSubscriptions(ugId), [r => ugtsSetEntities(r)]);
}

function* ugtsUnsubscribeGenerator(action: Action<UgtsSubscription>) {
    const tId = action.payload.tId;
    const ugId = action.payload.ugId;

    const api = getUserGroupAdminApi2();

    yield* fetchWrapperFunc(() => api.unsubscribeUserGroupToTournament(ugId, tId ));
    yield put(ugtsLoad(ugId));
}

function* ugtsSubscribeGenerator(action: Action<UgtsSubscription>) {
    const tId = action.payload.tId;
    const ugId = action.payload.ugId;

    const api = getUserGroupAdminApi2();

    yield* fetchWrapperFunc(() => api.subscribeUserGroupToTournament(ugId, tId ));
    yield put(ugtsLoad(ugId));
}

function* watchForUgtsActions() {
    yield takeLatest(UGTS_LOAD, ugtsLoadGenerator);
    yield takeLatest(UGTS_SUBSCRIBE, ugtsSubscribeGenerator);
    yield takeLatest(UGTS_UNSUBSCRIBE, ugtsUnsubscribeGenerator);
}

export function* ugtsSagas() {
    yield all([watchForUgtsActions()]);
}
